<template lang="pug">
div.layer
  template(v-if="placement === 'fill-area'")
    img.center-image(:src="image", :style="style")
  template(v-if="placement === 'offset-from-center'")
    img.offset-image(:src="image", :style="style", :width="imageWidth")
</template>

<script>

export default {

  components : {
  },

  props : ['effect', 'from', 'to', 'image', 'container', 'placement', 'offset', 'imageWidth'],

  name: 'effect',

  data() {

    return {

      progress : 0,
      style : '',

      // Generic properties
      eventHub : window.vueEventHub

    }
  },

  computed : {


  },

  watch : {

    progress : function(val) {


      let ty = -50

      if (this.effect === 'parallax') {
        ty = 100 * (this.from + (this.to - this.from) * val) - 50
      }

      let posTransform = `transform: translateX(-50%) translateY(${ty}%)`

      if (this.placement === 'fill-area') {
        posTransform = `${posTransform} scale(1.05)`
      }

      if (this.placement === 'offset-from-center') {
        let [x = 0, y = 0] = this.offset
        if (x.indexOf('-') === 0) {
          x = '- ' + x.split('-')[1]
        } else {
          x = '+ ' + x
        }
        if (y.indexOf('-') === 0) {
          y = '- ' + y.split('-')[1]
        } else {
          y = '+ ' + y
        }
        this.style = `left: calc(50% ${x}); top: calc(50% ${y});${posTransform}`
      } else {
        this.style = posTransform
      }

      if (this.effect === 'focal-shift') {

        let tb = (this.from + (this.to - this.from) * val)
        this.style = `${this.style};filter:blur(${tb}px)`

      }

    }
  },

  async created() {

    if (this.placement === 'fill-area') {
      this.style = 'transform: translateX(-50%) translateY(-50%)'
    }

    if (this.placement === 'offset-from-center') {
      let [x = 0, y = 0] = this.offset
      if (x.indexOf('-') === 0) {
        x = '- ' + x.split('-')[1]
      } else {
        x = '+ ' + x
      }
      if (y.indexOf('-') === 0) {
        y = '- ' + y.split('-')[1]
      } else {
        y = '+ ' + y
      }
      this.style = `left: calc(50% ${x}); top: calc(50% ${y});transform: translateX(-50%) translateY(-50%)`
    }

    this.eventHub.$on('intersection-update', this.update)
  },

  methods : {

    update({ container, progress }) {

      if (container !== this.container) {
        return
      }

      this.progress = progress

    },

    cdnImage(src) {
      return `${CDN_URL_PREFIX}${src}`
    }

  }
}
</script>

<style lang="scss">
.layer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.center-image {
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  transform-origin: center center;
}

.offset-image {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  transform-origin: center center;
}
</style>


// WEBPACK FOOTER //
// CMSEffect.vue?b5cd9900